import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import Form from './Form';
import styles from './styles';
import RouterLink from '../../components/RouterLink';
import { AccessTokenStorage } from '../../services/tokenStorage';
import useAuth from '../../hooks/useAuth';
import { useAppSelector } from '../../store';
import Logo from '../../components/Logo';
import Promotion from '../../assets/promotion/login-promotion.png';

function Register() {
  const { t } = useTranslation('auth');
  const { registerFirstStep } = useAuth();
  const location = useLocation();

  const submitting = useAppSelector(state => state.auth.register.loading);

  const token = AccessTokenStorage.getToken();
  if (token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return (
    <Box sx={styles.container}>
      <Box sx={styles.leftContainer}>
        <Box sx={styles.logo}>
          <Logo />
          <Typography sx={styles.logoSubtitle} variant="h6" textAlign="center">
            {t('privacy')}
            <br />
            {t('kitchen_title')}
          </Typography>
        </Box>
        <Box sx={styles.promotion}>
          <img
            src={Promotion}
            alt=""
            height="100%"
            width="100%"
            title="promotion-picture"
          />
        </Box>
      </Box>
      <Box sx={styles.rightContainer}>
        <Box sx={styles.formContainer}>
          <Typography
            variant="h5"
            fontWeight="bold"
            textAlign="center"
            sx={{ mb: 1 }}
          >
            {t('register.title')}
          </Typography>
          <Typography variant="subtitle1" textAlign="center">
            <Trans
              i18nKey="auth:register.subtitle"
              components={[<RouterLink to="/login" />]}
            />
          </Typography>
          <Form onValidSubmit={registerFirstStep} submitting={submitting} />
        </Box>
      </Box>
    </Box>
  );
}

export default Register;
